<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Input Kas Mutasi</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <h6 class="form-title mb-2">Upload Data Kas Mutasi (HO ke Cabang) [MANDIRI]</h6>
                    <b-form-group label="Upload Data Kas Mutasi (Mandiri)">
                        <b-form-file
                            v-model="input.fileMutasiHoCabang" name="fileMutasiHoCabang"
                            :state="Boolean(input.fileMutasiHoCabang)"
                            placeholder="Choose a file"
                            drop-placeholder="Drop file here..."
                            accept=".csv"
                            required>
                        </b-form-file>
                        <b-button class="ml-4 mt-2" type="submit" name="kasMutasiSubmitBtn" variant="pgiBtn">Kirim</b-button>
                    </b-form-group>
                </div>
            </b-form>

            <hr />

            <b-form @submit.prevent="openModalConfirmBri">
                <div class="form-content-wrapper">
                    <h6 class="form-title mb-2">Upload Data Kas Mutasi (HO ke Cabang) [BRI]</h6>
                    <b-form-group label="Upload Data Kas Mutasi (BRI)">
                        <b-form-file
                            v-model="input.fileMutasiHoCabangBRI" name="fileMutasiHoCabangBRI"
                            :state="Boolean(input.fileMutasiHoCabang)"
                            placeholder="Choose a file"
                            drop-placeholder="Drop file here..."
                            accept=".csv"
                            required>
                        </b-form-file>
                        <b-button class="ml-4 mt-2" type="submit" name="kasMutasiSubmitBRIBtn" variant="pgiBtn">Kirim</b-button>
                    </b-form-group>
                </div>
            </b-form>

            <hr>

            <b-form @submit.prevent="openModalConfirm2">
                <div class="form-content-wrapper">
                    <h6 class="form-title mb-2">Upload Data Kas Mutasi (Cabang ke Cabang)</h6>
                    <b-form-group label="Upload Data Kas Mutasi">
                        <b-form-file
                            v-model="input.fileMutasiCabangToCabang" name="fileMutasiCabangToCabang"
                            :state="Boolean(input.fileMutasiCabangToCabang)"
                            placeholder="Choose a file"
                            drop-placeholder="Drop file here..."
                            accept=".csv"
                            required>
                        </b-form-file>
                        <b-button class="ml-4 mt-2" type="submit" name="kasMutasiSubmitBtn" variant="pgiBtn">Kirim</b-button>
                    </b-form-group>
                </div>
            </b-form>

            <hr>

            <b-form @submit.prevent="openModalConfirm3">
                <div class="form-content-wrapper">
                    <h6 class="form-title mb-2">Manual</h6>
                    <b-form-group label="Cabang Dari">
                        <div>
                            <multiselect
                                name="dariCabang"
                                v-model="input.cabangKasMutasiDari" 
                                :options="cabangKasMutasiOption" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih Cabang Sumber --"
                            />
                        </div>
                    </b-form-group>
                    <b-form-group label="Cabang Tujuan">
                        <div>
                            <multiselect
                                name="dariCabang"
                                v-model="input.cabangKasMutasiTujuan" 
                                :options="cabangKasMutasiOption" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih Cabang Tujuan --"
                            />
                        </div>
                    </b-form-group>
                    <b-form-group label="Nominal">
                        <b-input-group prepend="Rp.">
                            <b-form-input v-model="input.nominalKasMutasi" name="nominalKasMutasi" required></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label="Keterangan">
                        <b-form-textarea v-model="input.keteranganKasMutasi" name="keteranganKasMutasi"></b-form-textarea>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="kasMutasiSubmitBtn" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-input-csv" title="Confirm Input Kas Mutasi HO ke Cabang (Mandiri)" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput kas mutasi (CSV) ini?" @submit="onSubmit" />
        <ModalConfirm id="modal-confirm-input-csv-bri" title="Confirm Input Kas Mutasi HO ke Cabang (BRI)" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput kas mutasi (CSV) ini?" @submit="onSubmitBRI" />
        <ModalConfirm id="modal-confirm-cabangToCabang" title="Confirm Input Kas Mutasi Cabang ke Cabang(CSV)" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput kas mutasi (CSV) ini?" @submit="onSubmit2" />
        <ModalConfirm id="modal-confirm-input-manual" title="Confirm Input Kas Mutasi (Manual)" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput kas mutasi (Manual) ini?" @submit="onSubmit3" />
    </div>
</template>

<script>
export default {
    name: 'input-kas-mutasi',
    data(){
        return{
            initStatus: 0,
            isSubmitting: false,
            input: {
                fileMutasiHoCabang: null,
                fileMutasiHoCabangBRI: null,
                fileMutasiCabangToCabang: null,

                cabangKasMutasiDari: null,
                cabangKasMutasiTujuan: null,
                nominalKasMutasi: null,
                keteranganKasMutasi: ""
            },
            cabangKasMutasiOption: [],
            srcCabangId: -1,
        }
    },
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.srcCabangId = this.$helper.getCabangId()

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    this.cabangKasMutasiOption.push(element)
                })
            })

            Promise.all([getCabang]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
            
        },


        //----------------- Fungsi Submit Data Input Kas CSV -----------------

        onSubmit() {
            let payload = new FormData()

            //----------------- Append Data Kas Mutasi -----------------

            payload.append("cabangSrcId", this.srcCabangId)
            payload.append("csv", this.input.fileMutasiHoCabang)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("cabang/kas/mutasi/ho_cabang/input", payload).then(() => {
                this.$helper.setFlash(`Input kas mutasi (CSV) baru berhasil dibuat!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        onSubmitBRI() {
            let payload = new FormData()

            //----------------- Append Data Kas Mutasi -----------------

            payload.append("cabangSrcId", this.srcCabangId)
            payload.append("csv", this.input.fileMutasiHoCabangBRI)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("cabang/kas/mutasi/ho_cabang/input_bri", payload).then(() => {
                this.$helper.setFlash(`Input kas mutasi (CSV) baru berhasil dibuat!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        //----------------- Fungsi Submit Data Input Kas CSV -----------------

        onSubmit2() {
            let payload = new FormData()

            //----------------- Append Data Kas Mutasi -----------------

            payload.append("cabangSrcId", this.srcCabangId)
            payload.append("csv", this.input.fileMutasiCabangToCabang)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            this.$axios.post("cabang/kas/mutasi/cabang_cabang_bulk/input", payload).then(() => {
                this.$helper.setFlash(`Input kas mutasi (CSV) baru berhasil dibuat!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Submit Data Input Kas Manual -----------------

        onSubmit3() {
            let payload = new FormData()

            let nominalKasMutasi = this.$helper.removeThousandSeparator(this.input.nominalKasMutasi);

            //----------------- Append Data Kas Mutasi -----------------

            payload.append("cabangSrcId", this.input.cabangKasMutasiDari.id)
            payload.append("cabangDestId", this.input.cabangKasMutasiTujuan.id)
            payload.append("nominal", nominalKasMutasi)
            if (this.$helper.isNotNullAndNotEmpty(this.input.keteranganKasMutasi))
            payload.append("keterangan", this.input.keteranganKasMutasi)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("cabang/kas/mutasi/cabang_cabang/input", payload).then(() => {
                this.$helper.setFlash(`Input kas mutasi (Manual) baru berhasil dibuat!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            this.$bvModal.show("modal-confirm-input-csv")
        },

        openModalConfirmBri(){
            this.$bvModal.show("modal-confirm-input-csv-bri")
        },

        openModalConfirm2(){
            this.$bvModal.show("modal-confirm-cabangToCabang")
        },

        openModalConfirm3(){
            if(this.input.cabangKasMutasiDari == null){
                this.$helper.toastErr(this, "Cabang Dari tidak boleh kosong!")
            }else if(this.input.cabangKasMutasiTujuan == null){
                this.$helper.toastErr(this, "Cabang Tujuan tidak boleh kosong!")
            }else if (this.input.cabangKasMutasiDari == this.input.cabangKasMutasiTujuan) {
                this.$helper.toastErr(this, "Cabang Dari tidak boleh sama dengan Cabang Tujuan")
            }else {
                this.$bvModal.show("modal-confirm-input-manual")
            }
        }
    },

    watch: {
        "input.nominalKasMutasi": function(newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.nominalKasMutasi = result);
        },
    },

    created(){
        this.init()
    }

}
</script>
